import { useEffect, useState } from "react";
import Sidebar from "./Sidebar";

export default function Photo() {
  const [title, setTitle] = useState("");
  const [image, setImage] = useState(null);
  const [photos, setPhotos] = useState([]);
  const [selectedId, setSelectedId] = useState(null);

  // fetch photos
  const loadPhotos = async () => {
    const res = await fetch("https://drpatangecitydentalclinic.com/api/allphoto.php");
    const data = await res.json();
    setPhotos(data);
  };

const handleSelect = (photo) => {
  setSelectedId(photo.id);
  setTitle(photo.title);
};

  useEffect(() => {
    loadPhotos();
  }, []);

  // upload photo
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title", title);
    formData.append("image", image);

    await fetch("https://drpatangecitydentalclinic.com/api/photo.php", {
      method: "POST",
      body: formData,
    });

    setTitle("");
    setImage(null);
    loadPhotos();
  };

  // delete photo
const handleDelete = async (id) => {
  const confirmDelete = window.confirm("Are you sure you want to delete this photo?");

  if (!confirmDelete) return;

  const formData = new FormData();
  formData.append("id", id);

  await fetch("https://drpatangecitydentalclinic.com/api/deletephoto.php", {
    method: "POST",
    body: formData,
  });

  loadPhotos();
};

  return (
    <div className="container-fluid p-4">
 <div className="row">

        <div className="col-md-3 col-lg-2 p-0">
          <Sidebar />
        </div>

        <div className="col-md-9 col-sm-12 col-lg-10 p-4">
      <h2 className="mb-4">Photo Gallery</h2>

      {/* FORM */}
      <form onSubmit={handleSubmit} className="card p-3 mb-4 shadow">
        <input
          className="form-control mb-2"
          placeholder="Photo Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />

        <input
          type="file"
          className="form-control mb-2"
          onChange={(e) => setImage(e.target.files[0])}
          required
        />

<button className="btn btn-primary w-100">
  {selectedId ? "Update Photo" : "Upload Photo"}
</button>      </form>

      {/* GRID */}
<table className="table table-bordered table-hover">
  <thead className="table-dark">
    <tr>
      <th>ID</th>
      <th>Image</th>
      <th>Title</th>
      <th>Actions</th>
    </tr>
  </thead>

  <tbody>
    {photos.map((p) => (
      <tr key={p.id}>

        <td>{p.id}</td>

        <td>
          <img
            src={p.image}
            alt=""
            style={{
              width: "70px",
              height: "70px",
              objectFit: "cover",
              borderRadius: "6px",
            }}
          />
        </td>

        <td>{p.title}</td>

        <td>
          <button
            className="btn btn-primary btn-sm me-2"
            onClick={() => handleSelect(p)}
          >
            Select
          </button>

          <button
            className="btn btn-danger btn-sm"
            onClick={() => handleDelete(p.id)}
          >
            Delete
          </button>
        </td>

      </tr>
    ))}
  </tbody>
</table>
      </div>

    </div>
</div>
  );
}